import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import * as QueryString from "query-string";
import { userActions } from "../../actions";

function MfaPage(props) {
    const { verifyMfa, location } = props;

    const params = QueryString.parse(location?.search);
    const t = params.t;
    const user_id = params.u;

    const [state, setState] = useState({
        code: "",
        submitted: false,
    });

    var bcrypt = require("bcryptjs");
    var salt = bcrypt.genSaltSync(10);



    const mfaWord = t === 'sms' ? "phone" : "email";

    function handleChange(e) {
        const { name, value } = e.target;
        setState({ ...state, [name]: value });
    }

    function handleSubmit(e) {
        e.preventDefault();

        const { code } = state;
        if (code) {

            verifyMfa(code, user_id);
        }
    }

    return (
        <>

            <div className="login">
                <span className="orgDetailTileHeader">
                    One more step...

                    <br /><br />
                    Please enter the six digit code we just sent to your {mfaWord}.
                    <br /><br /><br />
                </span>

                <TextField
                    autoFocus
                    name="code"
                    onChange={handleChange}
                />

                <br /><br />

                <Button variant="outlined" color="primary" onClick={handleSubmit}>
                    Submit
                </Button>
                <br />


            </div>

        </>
    );
}

function mapStateToProps(state) {
    const { authentication } = state;
    return {
        authentication,
    };
}

const actionCreators = {
    verifyMfa: userActions.verifyMfa,
};

const connectedMfaPage = connect(mapStateToProps, actionCreators)(MfaPage);
export { connectedMfaPage as MfaPage };
